// Check if the module exists before doing anything
const workableExists = !!document.querySelector('.workable-feed');
// console.log(workableExists);
// If the module exists, do whatever we need to

const workableFeed = {
    selectedDepartment: 'All',
    selectedLocation: 'All',

    allDepartments: document.querySelectorAll('[id^="cct-department-"]'),
    allLocations: [],

    departmentChange: (event) => {
        workableFeed.selectedDepartment = event.target.value;
        workableFeed.handleAccordionVisible();
        workableFeed.handleDepartmentVisible();
    },
    locationChange: (event) => {
        workableFeed.selectedLocation = event.target.value;
        workableFeed.handleAccordionVisible();
        workableFeed.handleDepartmentVisible();
    },

    handleAccordionVisible: () => {
        workableFeed.allLocations.forEach((locationAccordion) => {
            if (
                workableFeed.selectedLocation === 'All' &&
                workableFeed.selectedDepartment === 'All'
            ) {
                locationAccordion.classList.remove('hidden');
            } else if (
                workableFeed.selectedLocation === 'All' &&
                locationAccordion.dataset.department ===
                    workableFeed.selectedDepartment
            ) {
                locationAccordion.classList.remove('hidden');
            } else if (
                workableFeed.selectedDepartment === 'All' &&
                locationAccordion.dataset.location ===
                    workableFeed.selectedLocation
            ) {
                locationAccordion.classList.remove('hidden');
            } else if (
                locationAccordion.dataset.department ===
                    workableFeed.selectedDepartment &&
                locationAccordion.dataset.location ===
                    workableFeed.selectedLocation
            ) {
                locationAccordion.classList.remove('hidden');
            } else {
                locationAccordion.classList.add('hidden');
            }
        });
    },

    handleDepartmentVisible: () => {
        let noOfHiddenDepartments = 0;
        workableFeed.allDepartments.forEach((department) => {
            const accordions = department.querySelectorAll('.accordion-item');

            let hideDepartment = true;
            accordions.forEach((accordion) => {
                if (accordion.classList.contains('hidden') !== true) {
                    hideDepartment = false;
                }
            });

            if (hideDepartment === true) {
                department.classList.add('hidden');
                noOfHiddenDepartments += 1;
            } else {
                department.classList.remove('hidden');
            }
        });
        // if we are hiding all the departments show a message
        const feedError = document.querySelector(
            '.workable-feed__error--filters'
        );
        if (noOfHiddenDepartments === workableFeed.allDepartments.length) {
            feedError.classList.remove('hidden');
        } else {
            feedError.classList.add('hidden');
        }
    },

    initWorkable: () => {
        // console.log('initWorkable');
        workableFeed.allDepartments = document.querySelectorAll(
            '[id^="cct-department-"]'
        );
        // depSelect locSelect
        const departmentSelect = document.querySelector('#depSelect');
        if (typeof departmentSelect !== 'undefined') {
            departmentSelect.addEventListener(
                'change',
                workableFeed.departmentChange
            );
        }

        const locationSelect = document.querySelector('#locSelect');
        if (typeof locationSelect !== 'undefined') {
            locationSelect.addEventListener(
                'change',
                workableFeed.locationChange
            );
        }

        // get all the accordions
        workableFeed.allDepartments.forEach((element) => {
            // console.log(element.querySelectorAll('.accordion-item'));
            workableFeed.allLocations = workableFeed.allLocations.concat(
                Array.from(element.querySelectorAll('.accordion-item'))
            );
        });
        // console.log(workableFeed.allLocations);
    },
};

if (workableExists) {
    workableFeed.initWorkable();
}

// Need to remove default when running storybook
export default workableFeed;
